import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Modal } from "react-bootstrap";
import Swal from "sweetalert2";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import "./style.css";
// hooks
import useAuth from "../../../hooks/useAuth";
//validation schema
import { SupplierLocationValidationSchema } from "../../../Validations/supplier/SupplierLocationValidation";
// redux
import { useDispatch, useSelector } from "../../../redux/store";
import { getCountries, getStates } from "../../../redux/slices/common";
import { resetLoading, saveSupplierLocation } from "../../../redux/slices/user";
// utils
import axios from "../../../utils/axios";
import { getAddress } from "../../../redux/slices/Customer";
//-------------------------------------------------------------

const AddSupplierLocation = ({
  locationType,
  handleClose,
  locationDetails,
  checkout,
  addressArr,
  visible,
}) => {
  const { user } = useAuth();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const { Address } = useSelector((state) => state.customer);
  const [phoneErr, setPhoneErr] = useState({
    isError: false,
    message: "",
  });
  const [changeHandler, setChangeHandler] = useState(false);
  const [countriesForInput, setCountriesForInput] = useState([]);
  const [defaultCheck, setDefaultCheck] = useState(false);
  const [handleSame, setHandleSame] = useState(false);
  const [disableSave, setDisableSave] = useState(false);
  const [shippingStates, setShippingStates] = useState([]);
  const [countryType, setCountryType] = useState(locationType);
  const [shippingCountryData, setShippingCountryData] = useState({});
  const [shippingRawPhone, setShippingRawPhone] = useState("");
  const [rawPhone, setRawPhone] = useState(
    locationDetails !== "" && locationDetails !== undefined
      ? locationDetails?.phoneCode + locationDetails?.phone
      : ""
  );
  const [countryId, setCountryId] = useState(
    locationDetails !== "" && locationDetails !== undefined
      ? locationDetails?.country?.id
      : ""
  );
  const [stateValue, setStateValue] = useState(
    locationDetails !== "" && locationDetails !== undefined
      ? locationDetails?.state?.id
      : ""
  );

  const { isLoading, countries, states } = useSelector((state) => state.common);
  const { isLocationSaved, locationData, error } = useSelector(
    (state) => state.user
  );

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = useForm({
    mode: ["onChange", "all"],
    resolver: yupResolver(SupplierLocationValidationSchema),
    defaultValues: {
      name: `${user.first_name} ${user.last_name}`,
    },
  });

  const loadDataOnlyOnce = useCallback(async () => {
    await axios.post("/get-states", { countryId }).then((item) => {
      //
      setShippingStates(item.data.states);
    });
  }, [states]);

  useEffect(() => {
    loadDataOnlyOnce();
    dispatch(getCountries());

    //
    if (error) {
      Swal.fire({
        icon: "error",
        text: error?.message,
      });
      dispatch(resetLoading());
      handleClose();
    }
    if (isLocationSaved === true) {
      if (locationData.success) {
        Swal.fire({
          icon: "success",
          text: locationData?.message,
        });
        if (checkout) {
          if (locationDetails !== "" && locationDetails !== undefined) {
            navigate(
              `/checkout?L_Type=${locationType}&L_ID=${locationDetails?.id}`
            );
          }
        }
      } else {
        Swal.fire({
          icon: "error",
          text: locationData?.message,
        });
      }
      dispatch(resetLoading());
      handleClose();
    }
    if (locationDetails && !changeHandler) {
      setCountryId(locationDetails?.country?.id);
      setStateValue(locationDetails?.state?.id);
      setValue("shippingcountry", locationDetails?.country?.id);
      setValue("shippingstate", locationDetails?.state?.id);
    }
  }, [
    dispatch,
    isLocationSaved,
    locationData,
    states,
    loadDataOnlyOnce,
    locationDetails,
  ]);

  const handleShippingCountryChange = (event) => {
    setChangeHandler(true);
    let countryId = event.target.value;
    setCountryId(countryId);
    dispatch(getStates(countryId));
    setCountryType(locationType);
    setValue("shippingcountry", countryId);
  };

  const handleShippingStateChange = (event) => {
    setChangeHandler(true);
    let stateId = event.target.value;
    setStateValue(stateId);
  };

  const handleSetDefault = () => {
    setDefaultCheck((prev) => !prev);
  };

  const handleAddLocationSubmit = (data) => {
    setDisableSave(true);
    if (
      locationType == "billing" &&
      Address.billingAddresses.length == 0 &&
      locationDetails == ""
    ) {
      dispatch(
        saveSupplierLocation(
          {
            ...data,
            is_default: 1,
            shippingCountryData: JSON.stringify(shippingCountryData),
            shippingphone: shippingRawPhone,
          },
          user.id
        )
      );
      return;
    } else if (
      locationType == "shipping" &&
      Address.shippingAddresses == 0 &&
      locationDetails == ""
    ) {
      dispatch(
        saveSupplierLocation(
          {
            ...data,
            is_default: 1,
            shippingCountryData: JSON.stringify(shippingCountryData),
            shippingphone: shippingRawPhone,
          },
          user.id
        )
      );

      return;
    }

    if (defaultCheck) {
      dispatch(
        saveSupplierLocation(
          {
            ...data,
            is_default: 1,
            shippingCountryData: JSON.stringify(shippingCountryData),
            shippingphone: shippingRawPhone,
          },
          user.id
        )
      );
      dispatch(resetLoading());
      return;
    }

    dispatch(
      saveSupplierLocation({
        ...data,
        shippingCountryData: JSON.stringify(shippingCountryData),
        shippingphone: shippingRawPhone,
      })
    );
    dispatch(resetLoading());
  };

  const setSameAddress = (e) => {
    setHandleSame((prev) => !prev);
  };
  useEffect(() => {
    dispatch(getCountries());
    dispatch(getAddress({ user_id: user.id }));
  }, []);

  return (
    <>
      <Modal
        size="sm"
        show={true}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable={true}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            {locationDetails !== "" ? <>Edit</> : <>Add</>}{" "}
            {locationType.charAt(0).toUpperCase() +
              locationType.slice(1).toLowerCase()}{" "}
            Address
          </Modal.Title>
        </Modal.Header>

        <Modal.Body
          style={{
            maxHeight: "calc(100vh - 210px)",
            overflowY: "auto",
          }}
        >
          <section className="mb-2">
            <div className="row">
              <div className="col-md-6">
                {locationDetails !== "" && (
                  <input
                    type="hidden"
                    name="locationId"
                    value={locationDetails.id}
                    {...register("locationId")}
                  />
                )}
                <input
                  type="hidden"
                  name="locationType"
                  value={locationType}
                  {...register("locationType")}
                />
                <div className="form-group">
                  <label>
                    Address <span className="req_input">*</span>
                  </label>
                  <textarea
                    placeholder={`Enter ${
                      locationType.charAt(0).toUpperCase() +
                      locationType.slice(1).toLowerCase()
                    } Address`}
                    rows="3"
                    className={`form-control ${
                      errors.shippingaddress ? "is-invalid" : ""
                    }`}
                    name="shippingaddress"
                    {...register("shippingaddress")}
                    defaultValue={locationDetails?.address}
                  ></textarea>
                  <div className="text-danger">
                    {errors.shippingaddress?.message}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Country <span className="req_input">*</span>
                  </label>
                  <select
                    // className="form-select"
                    aria-label="Default select example"
                    name="shippingcountry"
                    {...register("shippingcountry")}
                    className={`form-select ${
                      errors.shippingcountry ? "is-invalid" : ""
                    }`}
                    onChange={handleShippingCountryChange}
                    autoComplete="nope"
                    // defaultValue={locationDetails.country?.id}
                    defaultValue={countryId}
                  >
                    <option value="">Select Country </option>
                    {countries !== null &&
                      countries !== undefined &&
                      countries.map((item, index) => (
                        <option key={index} value={item.id}>
                          {item.trans.name}
                        </option>
                      ))}
                  </select>
                  <div className="text-danger">
                    {errors.shippingcountry?.message}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    State <span className="req_input">*</span>
                  </label>
                  <select
                    // className="form-select"
                    name="shippingstate"
                    aria-label="Default select example"
                    {...register("shippingstate")}
                    className={`form-select ${
                      errors.shippingstate ? "is-invalid" : ""
                    }`}
                    value={stateValue}
                    onChange={handleShippingStateChange}
                  >
                    <option value="">Select State </option>
                    {shippingStates !== null &&
                      shippingStates !== undefined &&
                      shippingStates.map((cItem, iKey) => (
                        <option key={iKey} value={cItem.id}>
                          {cItem.trans.name}
                        </option>
                      ))}
                  </select>
                  <div className="text-danger">
                    {errors.shippingstate?.message}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    City <span className="req_input">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter City"
                    className={`form-control ${
                      errors.shippingcity ? "is-invalid" : ""
                    }`}
                    name="shippingcity"
                    {...register("shippingcity")}
                    defaultValue={locationDetails?.city}
                  />
                  <div className="text-danger">
                    {errors.shippingcity?.message}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Pincode <span className="req_input">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Pincode"
                    maxLength={6}
                    className={`form-control ${
                      errors.shippingpincode ? "is-invalid" : ""
                    }`}
                    name="shippingpincode"
                    {...register("shippingpincode")}
                    defaultValue={locationDetails?.pincode}
                  />
                  <div className="text-danger">
                    {errors.shippingpincode?.message}
                  </div>
                </div>
              </div>
              {/* {
                countriesForInput != null &&
                countriesForInput != undefined &&
                countriesForInput != "" && 
                 */}
              <div className="col-md-6">
                <div className="form-group telflag">
                  <label>
                    Phone <span className="req_input">*</span>
                  </label>
                  <Controller
                    control={control}
                    name="shippingphone"
                    defaultValue={rawPhone}
                    render={({ field }) => {
                      const { name, value, onBlur, onChange } = field;
                      const props = {
                        name,
                        value,
                        onChange,
                        onBlur,
                      };
                      return (
                        <PhoneInput
                          onlyCountries={countriesForInput}
                          enableSearch={true}
                          countryCodeEditable={false}
                          className="input-control"
                          inputClass={`form-control 
                        ${errors?.shippingphone ? "is-invalid" : ""}`}
                          inputRef={register}
                          country={"in"}
                          {...props}
                          error={!!errors?.shippingphone}
                          inputStyle={{
                            width: "100%",
                            minHeight: "45px",
                          }}
                          searchClass="form-control"
                          isValid={(value, country) => {
                            setShippingCountryData(country);
                            setShippingRawPhone(
                              value.slice(country?.dialCode?.length)
                            );
                            // if (value.match(/12345/)) {
                            //   return (
                            //     "Invalid value: " + value + ", " + country.name
                            //   );
                            // } else if (value.match(/1234/)) {
                            //   return false;
                            // } else {
                            //   return true;
                            // }
                          }}
                        />
                      );
                    }}
                  />
                  <div className="text-danger">
                    {/* {phoneErr.isError && phoneErr.message} */}
                    {errors.shippingphone?.message}
                  </div>
                </div>
              </div>
              {/* }       */}
              <div className="col-md-6">
                <div className="form-group">
                  <label>
                    Email <span className="req_input">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Enter Email ID"
                    className={`form-control ${
                      errors.shippingemail ? "is-invalid" : ""
                    }`}
                    name="shippingemail"
                    {...register("shippingemail")}
                    defaultValue={locationDetails?.email}
                  />
                  <div className="text-danger">
                    {errors.shippingemail?.message}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Website</label>
                  <input
                    type="text"
                    placeholder="Enter Website"
                    className={`form-control ${
                      errors.shippingwebsite ? "is-invalid" : ""
                    }`}
                    name="shippingwebsite"
                    {...register("shippingwebsite")}
                    defaultValue={locationDetails?.website}
                  />
                  <div className="text-danger">
                    {errors.shippingwebsite?.message}
                  </div>
                </div>
              </div>
              <div
                className="d-flex flex-column"
                style={{ visibility: visible }}
              >
                {locationDetails !== "" && locationDetails.is_default === 1 ? (
                  <div
                    className="form-check form_checkv2 mt-3"
                    style={{ marginLeft: "0.5rem", maxWidth: "10rem" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      onClick={handleSetDefault}
                      id="flexCheckChecked"
                      checked={true}
                      disabled={true}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked"
                    >
                      Set it as Default
                    </label>
                  </div>
                ) : (
                  <div
                    className="form-check form_checkv2 mt-3"
                    style={{ marginLeft: "0.5rem", maxWidth: "10rem" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      onClick={handleSetDefault}
                      id="flexCheckChecked"
                      checked={defaultCheck}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexCheckChecked"
                    >
                      Set it as Default
                    </label>
                  </div>
                )}
                {locationDetails === "" && (
                  <div
                    className="form-check form_checkv2"
                    style={{ marginLeft: "0.5rem", maxWidth: "20rem" }}
                  >
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="setSameChecked"
                      onClick={setSameAddress}
                      checked={handleSame}
                      value={handleSame}
                      {...register("billing_shipping_same")}
                      name={"billing_shipping_same"}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="setSameChecked"
                    >
                      Set it same for{" "}
                      {locationType === "shipping" ? "billing" : "shipping"}
                    </label>
                  </div>
                )}
              </div>
            </div>
          </section>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={disableSave}
          >
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-primary"
            onClick={handleSubmit(handleAddLocationSubmit)}
            disabled={disableSave}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AddSupplierLocation;
